/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Hero_TitleInputs */

const en_blog_hero_title = /** @type {(inputs: Blog_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train smarter. Know why.`)
};

const pl_blog_hero_title = /** @type {(inputs: Blog_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenuj mądrzej. Wiedz dlaczego.`)
};

/**
* | output |
* | --- |
* | "Train smarter. Know why." |
*
* @param {Blog_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_hero_title = /** @type {((inputs?: Blog_Hero_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Hero_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_hero_title(inputs)
	return en_blog_hero_title(inputs)
});